module.exports = __webpack_public_path__ + "img/no_info.bc90a02c.png";